import { render, staticRenderFns } from "./ManagementAddContractorInfoWebsite.vue?vue&type=template&id=3c674b5b&scoped=true"
import script from "./ManagementAddContractorInfoWebsite.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoWebsite.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoWebsite.vue?vue&type=style&index=0&id=3c674b5b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c674b5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c674b5b')) {
      api.createRecord('3c674b5b', component.options)
    } else {
      api.reload('3c674b5b', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoWebsite.vue?vue&type=template&id=3c674b5b&scoped=true", function () {
      api.rerender('3c674b5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoWebsite.vue"
export default component.exports